import React from "react";

import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import CryptoJS from "crypto-js";
import { format } from "date-fns";

import server from "../../../functions/server";
import Header from "../Header";
import Desktop from "./components/desktop/index";
import Mobile from "./components/mobile/index";
import Cookies from 'js-cookie';

export default function Certificados() {
  const [status, setStatus] = React.useState(false);
  const [dados, setDados] = React.useState();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [url, setURL] = React.useState();
  const [newCertificate, setNewCert] = React.useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("1094"));

  let nome = localStorage.getItem("nomeparc");
  let user = localStorage.getItem("user");

  nome = CryptoJS.AES.decrypt(nome, "MedSys@341");
  nome = CryptoJS.enc.Utf8.stringify(nome);

  user = CryptoJS.AES.decrypt(user, "MedSys@341");
  user = CryptoJS.enc.Utf8.stringify(user);

  const closeModal = () => {
    setOpenDialog(false);
  };

  const handleSubmit = async () => {
    setStatus(true);

    const data_ini = "01/01/2001";
    const data_fin = "01/01/2100";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + Cookies.get('bearer'),
      },
      body: new URLSearchParams({
        jsonid: localStorage.getItem("token"),
        cgc_cpf: user,
        inicio: format(new Date(data_ini), "dd/MM/yyyy"),
        fim: format(new Date(data_fin), "dd/MM/yyyy"),
      }),
    };

    await fetch(`${server}portalCliente/consulta/devolucoes`, options)
      .then((response) => response.json())
      .then((resp) => {
        setDados(resp);

        const certificadosFormatados = resp.data.map((item) => ({
          id: item[10] || Math.random(),
          numnota: item[1],
          descrprod: item[7],
          serie: item[10],
          unique: item,
        }));

        const mapDeIds = [];
        const certificadosUnicos = [];

        certificadosFormatados.forEach((item) => {
          if (!mapDeIds.includes(item.serie)) {
            mapDeIds.includes(item.serie, true);
            certificadosUnicos.push(item);
          }
        });

        setNewCert(certificadosUnicos);
      });
  };

  if (!status) {
    handleSubmit();
  }

  const handleCertificate = () => {
    const series = dados.data.map((data) => data[10]);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + Cookies.get('bearer'),
      },
      body: new URLSearchParams({
        series: JSON.stringify(series),
        jsonid: localStorage.getItem("token"),
        nomeparc: nome,
        bu: localStorage.getItem("segmento"),
        serie: dados?.data?.[dados.data.length - 1]?.[10],
        codprod: dados?.data?.[dados.data.length - 1]?.[6],
        cnpj: nome?.trim?.(),
        nomeprod: dados?.data?.[0]?.[7],
      }),
    };

    fetch(`${server}portalCliente/gera_certificado`, options)
      .then((response) => response.text())
      .then((response) => {
        setURL(response);
        setOpenDialog(true);
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Header />

      {newCertificate.length > 0 ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center",
              alignItems: "center",
              padding: "1rem",
            }}
          >
            {!isMobile ? (
              <>
                <h2>Pedidos de Consumíveis</h2>
                <Button
                  variant="contained"
                  endIcon={<WorkspacePremiumIcon />}
                  onClick={handleCertificate}
                  sx={{
                    height: isMobile ? "15vh" : "6vh",
                  }}
                >
                  Acessar Certificado de todos os produtos
                </Button>
              </>
            ) : (
              <h2>Pedidos de Consumíveis</h2>
            )}
          </div>
          {isMobile ? (
            <Mobile
              newCertificate={newCertificate}
              nome={nome}
              server={server}
              setURL={setURL}
              setOpenDialog={setOpenDialog}
            />
          ) : (
            <Desktop
              newCertificate={newCertificate}
              nome={nome}
              server={server}
              setURL={setURL}
              setOpenDialog={setOpenDialog}
            />
          )}
        </>
      ) : (
        <LinearProgress />
      )}

      <Dialog open={openDialog} onClose={() => closeModal()} maxWidth={false}>
        <DialogTitle>Certificado de Autenticidade</DialogTitle>
        <DialogContent sx={{ width: "90vw", height: "90vh" }}>
          <iframe
            src={url}
            style={{ width: "100%", height: "100%", border: "none" }}
            title="Certificado de Autenticidade"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeModal()}>Fechar</Button>
          <Button
            loading={false}
            onClick={() => {
              window.open(url, "_blank");
            }}
          >
            Abrir em Nova Aba
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
